import styled from 'styled-components';

import { Grid } from 'coreOld/elements';

interface IGridContainerProps {
  isDisabled?: boolean;
}

export const WrapperNotification = styled.div`
  padding: 10px 30px;
`;

export const SectionTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 30px;
  align-items: center;
  font-weight: 600;
  margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const GridContainer = styled(Grid)<IGridContainerProps>`
  padding: 10px 14px;
  margin: 0;

  input {
    text-align: ${({ isDisabled }) => (isDisabled ? 'right' : 'inherit')};
  }
`;

export const GridItem = styled(Grid)`
  margin-right: 4em;
`;
